<ng-container>
    <div [innerHTML]="content"></div>
</ng-container>